import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface UserStore {
  lastIntroPlayDate: string | null
  setLastIntroPlayDate: (date: string) => void
}

export const useUser = create<UserStore>()(
  persist(
    (set) => ({
      lastIntroPlayDate: null,
      setLastIntroPlayDate: (date) => set({ lastIntroPlayDate: date }),
    }),
    {
      name: 'user-store',
      partialize: (state) => ({ lastIntroPlayDate: state.lastIntroPlayDate }),
      storage: createJSONStorage(() => localStorage),
      skipHydration: true,
    },
  ),
)
